import highcharts from 'highcharts';
import more from 'highcharts/highcharts-more';
import boost from 'highcharts/modules/boost';
import bellcurve from 'highcharts/modules/histogram-bellcurve';

more(highcharts);
bellcurve(highcharts);
boost(highcharts);
